import React from 'react'
import './WhyHireUs.css'
import WhuImg from '../../../../assets/img/whu.webp'
import pd from '../../../../assets/img/project_delivered.svg'
import hc from '../../../../assets/img/happy_clients.svg'
import tc from '../../../../assets/img/coffee.svg'
import CountUpOnScroll from '../../Home/About/ScrollCounter'

function WhyHIreUs() {
  return (
    <section className='whu-sec'>
        <div className='container'>
            <div className='whu-sec1'>
                <div className='whulft'></div>
                <div className='whurgt'>
                    <h3>What We Build</h3>
                    <ul>
                        <li>  B2B tools for operations, HR, finance, and analytics</li>
                        <li>  Vertical SaaS for healthcare, education, retail, hospitality and more</li>
                        <li>  Multi-tenant platforms with role-based access controls</li>
                        <li>  Billing, subscription management and usage tracking modules </li>
                    </ul>
                    
                </div>
            </div>
        </div>
    </section>
  )
}

export default WhyHIreUs
